import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AttendanceMetricPeriod, ProgramAttendanceMetricResponse} from '@models/attendance';

@Injectable({
  providedIn: 'root'
})
export class AttendanceService {

  constructor(
    private httpClient: HttpClient,
  ) { }

  checkIn(body: {user_id: number[], program_id: number, lesson_id: number, schedule_id: number}) {
    return  this.httpClient.post('attendance/checkIn', body);
  }
  unCheckIn(body: {attendance_id: number[]}) {
    return this.httpClient.post('attendance/unCheckIn', body);
  }
  getStudentAttendences(body: {user_id: number, period: string, day?: string}) {
    let path = 'attendance/' + body.user_id + '/' + body.period + '/' + body.day;
    if(body.day == undefined){
      path = 'attendance/' + body.user_id + '/' + body.period;
    }
    return  this.httpClient.get(path);
  }

  getProgramMetric(
    userId: number,
    programId: number,
    period: AttendanceMetricPeriod,
    capToNow = true
  ): Observable<ProgramAttendanceMetricResponse> {
    let params = new HttpParams()
      .set('period', period);

    if (capToNow) {
      params = params.set('cap_to_now', '1');
    }

    return this.httpClient.get<ProgramAttendanceMetricResponse>(
      'attendance/' + userId + '/program/' + programId + '/metrics',
      {params}
    );
  }

  getAllAttendences(body: {class_id: any, schedule_id: any, lesson_id?: any, day?: string}) {

    const lessonId = body.lesson_id ? '/' + body.lesson_id : '';
    let dayPath = '';
    if(lessonId){
      dayPath = body.day ? '/' + body.day : '';
    }
    return  this.httpClient.get('attendance/widget/' + body.schedule_id + '/' + body.class_id  + lessonId + dayPath);
  }

  getDayAttendences(body: {school_id: any, day?: string}) {
    let path = 'attendance/day/' + body.school_id + '/' + body.day;
    if(body.day == undefined){
      path = 'attendance/day/' + body.school_id;
    }
    return  this.httpClient.get(path);
  }

  getSchedule(schedule_id) {
    return this.httpClient.get('schedule/' + schedule_id);
  }

  getYearStatistic(body: {program_id?: number, curriculum_id?: number, user_id?: number}) {
    return  this.httpClient.post('attendance/yearStatistic', body);
  }
  getStudentConversation(program_id) {
    return this.httpClient.get('attendance/conversation/' + program_id);
  }
  getFundamentals(school_id) {
    return this.httpClient.get(school_id + 'attendance/checkIn');
  }
}
